<template>
  <div v-if="task.notification?.draft === true">
    <button class="btn btn-sm btn-secondary">
      SMS
    </button>
  </div>
  <div v-else>
    <button v-if="task.notification?.status === 'Pending' && !task.notification.errorMessage" class="btn btn-sm btn-warning" @click="sendNotification(task)">
      SMS
    </button>
    <button v-else-if="task.notification?.status === 'OK'" class="btn btn-sm btn-success" @click="sendNotification(task)">
      SMS
    </button>
    <div v-else>
      <div v-if="!task.notification">
        <button class="btn btn-sm btn-danger">
          SMS
        </button>
        <i tabindex="0" data-toggle="tooltip" title="Brak przypisanego SMS'a do Zlecenia" class="fa-solid fa-circle-info mx-2 sms-error-icon"></i>
      </div>
      <div v-else-if="task.notification.errorMessage">
        <button class="btn btn-sm btn-danger" @click="sendNotification(task)">
          SMS
        </button>
        <i tabindex="0" data-toggle="tooltip" :title="task.notification.errorMessage" class="fa-solid fa-circle-info mx-2 sms-error-icon"></i>
        <span role="button" @click="sendNotification(task)" class="text-decoration-underline">
          Wyślij ponownie
        </span>
      </div>
    </div>
    <div v-if="task.notification?.sendDate">
      {{ moment(task.notification.sendDate).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'SmsButton',
  props: ['task'],
  data () {
    return {
      moment: moment
    }
  },
  methods: {
    ...mapActions({
      sendNotification: 'notificationsModule/sendNotification'
    })
  }
}
</script>

<style scoped>
.sms-error-icon {
  font-size: 1.5rem;
  color: darkred;
  transition: .2s;
}

.sms-error-icon:hover {
  color: red;
  cursor: pointer;
}
</style>
